export default __webpack_public_path__ + "static/media/10.b09821a1.png";